// Fermeture des alertes
document.addEventListener('click', (e) => {
    const btn = e.target.closest('.alert__close');
    if (btn) btn.closest('.alert')?.remove();
});
